import { createSelector } from '@ngrx/store';

import { getReferenceCount } from './get.references.count';

export const getTotalReferenceCount = createSelector(
  getReferenceCount,
  ({ referencesCount, unnumberedReferencesCount, keywordCount }): number =>
    referencesCount + unnumberedReferencesCount + keywordCount
);
